export class BillItemViewModel {
    public lastBillStatus = false;
    public lastBillAmount: string;
    public lastBillDate: string;
}
